import { graphql } from 'gatsby';
import {
  getKey,
  isValidArray,
  getLink,
  exists
} from '../../../helpers';

/**
 * Cards Widget definition
 * @param {Object} props of the widget
 * @param {string} locale of the content
 * @returns {Object} definition of the widget
 */
export default function card(props, locale) {
  const items = getKey(props, 'items');

  return {
    widgetType: 'card',
    key: getKey(props, 'key'),
    items: isValidArray(items) && items.map(item => ({
      key: getKey(item, 'key'),
      backgroundImage: getKey(item, 'backgroundImage.childImageSharp.fluid'),
      title: getKey(item, `title_${locale}`),
      description: getKey(item, `description_${locale}`),
      htmlDescription: getKey(item, `htmlDescription_${locale}`),
      link: getLink(getKey(item, 'link'), locale),
      gradientColor: getKey(item, 'gradientColor', 'pink'),
      backgroundAlignment: exists(getKey(item, 'backgroundAlignment')) ? getKey(item, 'backgroundAlignment') : 'center',
      alt: getKey(item, `background_alt_${locale}`)
    }))
  };
}

/**
 * GraphQL definition
 */
export const query = graphql`
fragment Cards on StrapiWidgetrels {
  card {
    key: id
    items: carditems {
      key: id
      title_en
      title_es
      description_en
      description_es
      htmlDescription_en
      htmlDescription_es
      link
      gradientColor
      backgroundAlignment
      background_alt_es
      background_alt_en
      backgroundImage {
        childImageSharp {
          fluid(maxWidth: 800, quality: 80) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
    widgetPosition
  }
}
`;
